export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5499.ea3454dd.jpg";